// Func = limiting Scope for this file
var lastScrollTop = 0;
var scrollVertical = 20;

(function () {
    const DATE_FORMAT_VACATIONS = ($("#CheckInVacations").data("format") !== undefined && $("#CheckInVacations").data("format")) ? $("#CheckInVacations").data("format") : "d M yy";
    $(document).ready(function () {


        /* let firstEleNav = document.querySelector('#privary-navigation .primary-nav-1 a');
        firstEleNav.removeAttribute('href'); */

        //scroll down click
        if (document.getElementsByClassName('scroll-down').length > 0) {
            document.getElementsByClassName('scroll-down')[0].addEventListener('click', function () {
                animateTo('intro');
            });
            document.getElementsByClassName('scroll-down')[0].addEventListener('click', function (e) {
                e.preventDefault();
                animateTo(this.getAttribute('href').split('#')[1]); 
            });
        }



        $('.accordion_title').click(function () {
            $(this).closest('.accordion_list').find('.accordion_body').stop().slideUp('fast', function () {
                $(this).css('height', 'auto');
                $(this).closest('.accordion_item').toggleClass('active', $(this).is(':visible'));
            });

            $(this).next('.accordion_body').stop().slideToggle('fast', function () {
                $(this).css('height', 'auto');
                $(this).closest('.accordion_item').toggleClass('active', $(this).is(':visible'));
            });
        });

        $('.accordion-faq_title').click(function () {
            $(this).closest('.accordion-faq_list').find('.accordion-faq_body').stop().slideUp('fast', function () {
                $(this).css('height', 'auto');
                $(this).closest('.accordion-faq_item').toggleClass('active', $(this).is(':visible'));
            });

            $(this).next('.accordion-faq_body').stop().slideToggle('fast', function () {
                $(this).css('height', 'auto');
                $(this).closest('.accordion_item').toggleClass('active', $(this).is(':visible'));
            });
        });

        //header reserve tabs
        // let reserveTabs = document.getElementsByClassName('item-tab');
        // let reservetabsLength = reserveTabs.length;

        // for (let i = 0; i < reservetabsLength; i++) {
        //     reserveTabs[i].addEventListener('click', function () {
        //         let thisTarget = this.getAttribute('data-target');
        //         for (let j = 0; j < reservetabsLength; j++) {
        //             if (reserveTabs[j] !== this) {
        //                 reserveTabs[j].classList.remove('active');
        //                 document.getElementsByClassName('shit-m')[j].classList.remove('active');
        //             } else {
        //                 reserveTabs[j].classList.add('active');
        //             }
        //         }
        //         document.getElementById(thisTarget).classList.add('active');
        //     });
        // }
        
        let villas_booking_btn = document.getElementById("villas-booking_btn");
        let vacation_booking_btn = document.getElementById("vacationH-booking_btn")

        let buttons = []

        let header = document.querySelector(".header")

        if( villas_booking_btn && vacation_booking_btn ){
            
            buttons.push(villas_booking_btn)
            buttons.push(vacation_booking_btn)
    
            villas_booking_btn.addEventListener("click",function(){
                if(!this.classList.contains("active")) {
                    showBooking(this, "villas")
                } else {
                    hiddeBooking(this)
                }
            })
    
            vacation_booking_btn.addEventListener("click", function () {
                if(!this.classList.contains("active")) {
                    showBooking(this, "vacationHomes")
                } else {
                    hiddeBooking(this)
                }
            })

        }

        function hiddeBooking(button){
            let booking_container = document.querySelector("aside.booking")

            if(button.classList.contains("active")) {
                button.classList.remove("active")
                booking_container.classList.remove("open")
                header.classList.remove("open-booking")
            }
        }

        function showBooking(button, identification) {
            let booking_container = document.querySelector("aside.booking")
            let currentBooking = document.getElementById(identification)


            let bookings = document.querySelectorAll(".item.shit-m")


            // remove active from all bookings
            bookings.forEach((myBooking)=>{
                if(myBooking.classList.contains("active")) {
                    myBooking.classList.remove("active")
                }
            })
            // remove active from all header buttons
            buttons.forEach((button) => {
                if(button.classList.contains("active")) {
                    button.classList.remove("active")
                }
            })

            header.classList.add("open-booking")

            booking_container.classList.add("open")
            currentBooking.classList.add("active")
            button.classList.add("active")
        }



        //booking selectors change for adults and children
        let allSelectors = document.getElementsByClassName('js-selector');
        let allSelectorsLength = allSelectors.length;
        for (let t = 0; t < allSelectorsLength; t++) {
            allSelectors[t].addEventListener('click', function () {
                let movement = this.getAttribute('data');



                if (movement == 'down') {
                    let SelectorNumber = parseInt(this.nextElementSibling.innerHTML, 10);
                    SelectorNumber--;
                    if (SelectorNumber >= 0) {
                        this.nextElementSibling.innerHTML = '0' + SelectorNumber;
                        $('input[name="' + this.nextElementSibling.getAttribute('data') + '"]').attr('value', SelectorNumber);
                    }
                } else {
                    let SelectorNumber = parseInt(this.previousElementSibling.innerHTML, 10);
                    SelectorNumber++;
                    if (this.previousElementSibling.getAttribute('data') == 'beds') {
                        var selectorLimit = 24;

                    } else {
                        var selectorLimit = 3;

                    }
                    if (SelectorNumber <= selectorLimit) {
                        this.previousElementSibling.innerHTML = '' + SelectorNumber;
                        $('input[name="' + this.previousElementSibling.getAttribute('data') + '"]').attr('value', SelectorNumber);
                    }
                }

            });
        }

        //slider list gallery
        $('.slide-list-gallery').slick({
            accessibility: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            variableWidth: false,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $('.slider-menus__slider').slick({
            arrows: true,
            dots: false,
            slidesToShow: 3,
            speed: 700,
            responsive:[
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });

        $('.slider-featured-events__slider').slick({
            arrows: true,
            dots: false,
            slidesToShow: 3,
            speed: 700,
            responsive:[
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });

        $('.columns-slider__slider').slick({
            arrows: false,
            dots: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 700,
            appendDots:'.columns-slider__dots',
            autoplay: true,
            autoplaySpeed: 4000,
            responsive:[
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });


        //script food menu 
        document.querySelectorAll('.js-menu-tab').forEach((btn) => {
            btn.addEventListener('click', _ => {
            $('.js-menu-tab.active').removeClass('active');
            $(btn).addClass('active');
            $('.quad-menus__menu-content.active').removeClass('active');
            var tabNumber = $(btn).attr('data-menuid');
            var tabToOpen = ".quad-menus__menu-content[data-menuid='" + tabNumber + "']";
            $(tabToOpen).addClass('active');
            $('.quad-menus__tabs-image.active').removeClass('active');
            var imgToOpen = ".quad-menus__tabs-image[data-menuid='" + tabNumber + "']";
            $(imgToOpen).addClass('active');
            $('.name-bg.active').removeClass('active');
            var wordToOpen = ".name-bg[data-menuid='" + tabNumber + "']";
            $(wordToOpen).addClass('active');     
            });
        });

        const home_body = document.querySelector('body#home');
        const simple_landing = document.querySelector('body#simple-landing');

        if (home_body) {
            /*this function add a class to header when scroll down the page
            /* and change the logo by a new file if needed depending of mockup
            */
            scrollDownAction(20, 'scroll');
        } else {
            if (!simple_landing) {
                const logo_scroll = document.querySelector('.header__logo img').dataset.scroll;

                document.querySelector('.header__logo img').src = logo_scroll;
            }
        }


        if (!simple_landing) {
            // document.querySelector('#booking').addEventListener('click', function () {
            //     document.querySelector('.booking').classList.add('open');
            // });

            document.querySelector('#js-close-booking').addEventListener('click', function () {
                document.querySelector('.booking').classList.remove('open');
            });

            document.querySelector("#CheckInVacations").onkeyup = function (dis) {
                let getDate = $(dis.target).datepicker('getDate');
                $("#CheckInVacations--alt").val($.datepicker.formatDate("mm/dd/yy", getDate));
            };
            document.querySelector("#CheckOutVacations").onkeyup = function (dis) {
                let getDate = $(dis.target).datepicker('getDate');
                $("#CheckOutVacations--alt").val($.datepicker.formatDate("mm/dd/yy", getDate));
            };
            $("#CheckOutVacations").datepicker({
                //showOn: "both",
                //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
                //buttonImageOnly: true,
                dateFormat: DATE_FORMAT_VACATIONS,
                changeMonth: true,
                numberOfMonths: 1,
                beforeShowDay: (date) => calendarRange(date),
                onSelect: function (selectedDate) {
                    // UPDATE ALT INPUT
                    let getDate = $(this).datepicker('getDate');
                    $("#CheckOutVacations--alt").val($.datepicker.formatDate("mm/dd/yy", getDate));
                    //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
                }
            });
        }

        // Home header effect
        var currentSlide = 0;

        document.querySelectorAll('.info__box').forEach(infoBox => {
            let selectorVar = '.hiden-slide.' + infoBox.getAttribute('href');
            infoBox.addEventListener('mouseenter', function (e) {
                document.querySelector(selectorVar).classList.add('visible');
            });
            infoBox.addEventListener('mouseleave', function () {
                document.querySelector(selectorVar).classList.remove('visible');
            })
        })
        if (document.querySelector('#tablet-menu-js')) {
            document.querySelector('#tablet-menu-js').addEventListener('click', function () {
                document.querySelector('.tablet-menu-list').classList.add('open');
            });
            document.querySelector('#js-close-menu-tablet').addEventListener('click', function () {
                document.querySelector('.tablet-menu-list').classList.remove('open');
            });
        }


        if(document.getElementById("burgerMenu-js")){
            let burger_menu = document.getElementById("burgerMenu-js");
            let navigation = document.querySelector(".header__bottom");
            let burger_menu_label = document.querySelector("#burgerMenu-js span")

            burger_menu.addEventListener("click", () => {
                if(burger_menu.classList.contains("open")) {
                    navigation.classList.remove("open")
                    burger_menu.classList.remove("open")
                    burger_menu_label.textContent = "Menu"
                } else {
                    burger_menu_label.textContent = "Close"
                    navigation.classList.add("open")
                    burger_menu.classList.add("open")
                }
            })
        }
        //Call function with browser is resized.
        // $(window).resize(function (event) {
        // 	resizeWindow();
        // });
        // resizeWindow();

        //Acts when scroll down page.
        // $(window).scroll(function (event) {
        // 	scrollDown();
        // });

        // Main Nav Dropdown
        $("#primary-nav li").hover(function () {
            $(this).addClass("hover");
            $('ul.submenu', this).fadeIn(200);
        }, function () {
            $(this).removeClass("hover");
            $('ul.submenu', this).fadeOut(200);
        });

        $('.js-close-booking1').click(function(){
            $('#villas').removeClass('active');
            $('#header').removeClass('open-booking');
            $('.booking').removeClass('open');
            $('#villas-booking_btn').removeClass('active');
        });
        $('.js-close-booking2').click(function(){
            $('#vacationHomes').removeClass('active');
            $('#header').removeClass('open-booking');
            $('.booking').removeClass('open');
            $('#vacationH-booking_btn').removeClass('active');
        });

        //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
        let DATE_STYLE = [true];

        function calendarRange(date) {
            let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
            let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
            if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
                DATE_STYLE[1] = 'highlight-top';
            } else if (date > d1 && date < d2) {
                DATE_STYLE[1] = 'highlight';
            } else {
                DATE_STYLE[1] = '';
            }
            return DATE_STYLE;
        }

        //Check in and check out datepicker for booking engine
        const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "d M yy";
        $("#CheckIn").datepicker({
            //showOn: "both",
            //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            //buttonImageOnly: true,
            changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
            minDate: 0,
            beforeShowDay: (date) => calendarRange(date),
            onSelect: function (selectedDate) {
                let getDate = $(this).datepicker('getDate');
                let newDate = new Date(getDate.getTime());
                newDate.setDate(newDate.getDate() + 3);
                $("#CheckOut").datepicker("setDate", newDate);
                $("#CheckOut").datepicker("option", "minDate", selectedDate);
                // UPDATE ALT INPUTS
                $("#CheckIn--alt").val($.datepicker.formatDate(DATE_FORMAT, getDate));
                $("#CheckOut--alt").val($.datepicker.formatDate(DATE_FORMAT, newDate));
            }
        });
        document.querySelector("#CheckIn").onkeyup = function (dis) {
            $("#CheckIn--alt").val(dis.srcElement.value);
        };
        document.querySelector("#CheckOut").onkeyup = function (dis) {
            $("#CheckOut--alt").val(dis.srcElement.value);
        };
        $("#CheckOut").datepicker({
            //showOn: "both",
            //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            //buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
            numberOfMonths: 1,
            beforeShowDay: (date) => calendarRange(date),
            onSelect: function (selectedDate) {
                // UPDATE ALT INPUT
                let getDate = $(this).datepicker('getDate');
                $("#CheckOut--alt").val($.datepicker.formatDate(DATE_FORMAT, getDate));
                //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
            }
        });

        //Check in and check out datepicker for Vacations booking engine
        $("#CheckInVacations").datepicker({
            //showOn: "both",
            //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            //buttonImageOnly: true,
            changeMonth: true,
            dateFormat: DATE_FORMAT_VACATIONS,
            numberOfMonths: 1,
            minDate: 0,
            beforeShowDay: (date) => calendarRange(date),
            onSelect: function (selectedDate) {
                let getDate = $(this).datepicker('getDate');
                let newDate = new Date(getDate.getTime());
                newDate.setDate(newDate.getDate() + 3);
                console.log( newDate );
                $("#CheckOutVacations").datepicker("setDate", newDate);
                $("#CheckOutVacations").datepicker("option", "minDate", selectedDate);
                // UPDATE ALT INPUTS
                $("#CheckInVacations--alt").val($.datepicker.formatDate("mm/dd/yy", getDate));
                $("#CheckOutVacations--alt").val($.datepicker.formatDate("mm/dd/yy", newDate));
            }
        });


        //Check in and check out datepicker for Vacations Module booking engine
        const DATE_FORMAT_MODULE = ($("#CheckInModule").data("format") !== undefined && $("#CheckInModule").data("format")) ? $("#CheckInModule").data("format") : "d M yy";
        $("#CheckInModule").datepicker({
            //showOn: "both",
            //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            //buttonImageOnly: true,
            changeMonth: true,
            dateFormat: DATE_FORMAT_MODULE,
            numberOfMonths: 1,
            minDate: 0,
            beforeShowDay: (date) => calendarRange(date),
            onSelect: function (selectedDate) {
                let getDate = $(this).datepicker('getDate');
                let newDate = new Date(getDate.getTime());
                newDate.setDate(newDate.getDate() + 3);
                $("#CheckOutModule").datepicker("setDate", newDate);
                $("#CheckOutModule").datepicker("option", "minDate", selectedDate);
                // UPDATE ALT INPUTS
                $("#CheckInModule--alt").val($.datepicker.formatDate("mm/dd/yy", getDate));
                $("#CheckOutModule--alt").val($.datepicker.formatDate("mm/dd/yy", newDate));
            }
        });
        $("#CheckOutModule").datepicker({
            //showOn: "both",
            //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
            //buttonImageOnly: true,
            dateFormat: DATE_FORMAT_MODULE,
            changeMonth: true,
            numberOfMonths: 1,
            beforeShowDay: (date) => calendarRange(date),
            onSelect: function (selectedDate) {
                // UPDATE ALT INPUT
                let getDate = $(this).datepicker('getDate');
                $("#CheckOutModule--alt").val($.datepicker.formatDate("mm/dd/yy", getDate));
                //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
            }
        });

        // Map: Return to previous page button. Change body id to match map template's name.
        //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

        $('[data-fancybox]').fancybox({ toolbar: false, infobar: false, smallBtn: true, mobile: { clickSlide: "close" } });


        //animation of scroll vanilla JS
        function animateTo(target) {
            var gotoTarget = offset(document.getElementById(target)).top - 10;
            var from = window.pageYOffset
            var to = gotoTarget
            var duration = 1300;
            var start = new Date().getTime()
            var timer = setInterval(function () {
                var time = new Date().getTime() - start

                if (from <= to) {
                    var yH = easeInOutQuart(time, from, to - from, duration)
                } else {

                    var yH = easeInOutQuart(time, from, -(from - to), duration)
                }
                window.scrollTo(0, yH)
                if (time >= duration) clearInterval(timer)
            }, 1000 / 60);
            window.scrollTo(0, from)
        }
        //ease movement
        function easeInOutQuart(t, b, c, d) {
            if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
            return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
        }

        //window offset
        function offset(el) {
            var rect = el.getBoundingClientRect(),
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
        }

        //for Interactive Map
        document.querySelectorAll('.key-list li').forEach((btn, i) => {
            btn.addEventListener('click', _ => {
                document.querySelectorAll('.key-list li,.lightbox-content').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');

                document.querySelectorAll('.pin-item').forEach(room => {
                    room.classList.remove('active');
                    if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
                        room.classList.add('active');
                    }
                });
            });

            
            if (i === 0) btn.click();
        });
        //for Interactive Map
        document.querySelectorAll('.key-item').forEach((btn, i) => {
            btn.addEventListener('click', _ => {
                document.querySelectorAll('.key-item,.lightbox-content').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');

                document.querySelectorAll('.pin-item').forEach(room => {
                    room.classList.remove('active');
                    if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
                        room.classList.add('active');
                    }
                });
            });

            
            if (i === 0) btn.click();
        });

        var pinItems = document.querySelectorAll(".pin-item");

        pinItems.forEach(function (pinItem) {
            var icon = pinItem.querySelector(".icon");
            var lightboxContent = pinItem.querySelector(".lightbox-content");
            
            icon.addEventListener("click", function () {
                document.querySelectorAll(".lightbox-content.active").forEach(function (otherLightbox) {
                    otherLightbox.classList.remove("active");
                });
                
                lightboxContent.classList.toggle("active");
            });
        });


    });

    window.onload = function () {
        /*this function add a class to header when scroll down the page
        /* and change the logo by a new file if needed depending of mockup
        */
        let landing = document.querySelector('body#simple-landing');
        if (!landing) {
            scrollDownAction(scrollVertical, 'scroll');

            scrollW();
            window.addEventListener('scroll', function () {
                scrollW();
            })
        }

        $('.top-content .sym-slides').slick('slickFilter', ':not(.hiden-slide)');

    };

    //Load more blog

			$(".blog .item")
			.slice(0, 3)
			.show();
			$(".blog .item:hidden").css("opacity", 0);
			if ($(".blog .item:hidden").length == 0) {
				$("#loadMore1").css('display','none');
			} 
			$("#loadMore1").on("click", function(e) {
					$(".blog .item:hidden")
						.slice(0, 12)
						.slideDown("slow")
						.animate(
						{
							opacity: 1
						},
						{
							queue: false,
							duration: "slow"
						}
						);
					if ($(".blog .item:hidden").length == 0) {
						$("#loadMore1").fadeOut("slow");
					}
				e.preventDefault();
			});


}());



function scrollW() {
    //check scroll down or up for header styles
    let st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > scrollVertical) {
        if (st > lastScrollTop) {
            // downscroll code
            if (!document.getElementById('header').classList.contains('down')) {
                document.getElementById('header').classList.add('down');
                document.getElementById('header').classList.remove('up');
            }
        } else {
            // upscroll code
            // if (!document.getElementById('header').classList.contains('up')) {
            // 	document.getElementById('header').classList.add('up');
            // 	document.getElementById('header').classList.remove('down');
            // }
        }
    } else {
        if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
            document.getElementById('header').classList.remove('up');
            document.getElementById('header').classList.remove('down');
        }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

// RESTAURANT MENUS FILTER
document.querySelectorAll('.restMenus_filter li').forEach((btn, i) => {
    btn.addEventListener('click', _ => {
        document.querySelector('.restMenus_toggle').textContent = btn.textContent;
        document.querySelectorAll('.restMenus_filter li').forEach(b => b.classList.remove('active'));
        document.querySelector('.restMenus_filter').classList.remove('open');
        btn.classList.add('active');
        document.querySelectorAll('.restMenus_item').forEach(room => {
            room.classList.remove('active');
            room.querySelectorAll('.restMenus_cat:first-child .animate-fade').forEach(ele => {
                ele.classList.add('fade-in', 'visible');
            });
            if (btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag) {
                room.classList.add('active');
            }
        });
        document.querySelectorAll('.restMenus__hero img').forEach(img => {
            img.classList.remove('active');
        });
        var heroselector = document.querySelector('.restMenus__hero .' + btn.dataset.tag);
        heroselector.classList.add('active');

    });

    if (window.location.hash) {
        if (window.location.hash.substring(1) == btn.dataset.tag) {
            $('html, body').animate({
                scrollTop: $("#scrollAnchor").offset().top - 150
            }, 2000);
            btn.click();
        }
    } else if (i === 0) {
        btn.click();
    }

});
/* Restaurant Menus */
var thetagbtns = document.querySelectorAll('.restMenus_tag');

var menuwithtags = document.querySelectorAll('.restMenus_modal.havetags');
menuwithtags.forEach(mwt => {
    mwt.querySelectorAll('.restMenus_cat').forEach(menucat => {
        menucat.classList.add('active');
    });
});

console.log(window.location.hash.substring(1));
if (window.location.hash.substring(1) == 'menu749' && document.querySelector('body#menus')) {
    document.querySelector('li[data-tag="menu749"]').click();
    var detagbtn = document.querySelector('a[data-timetag=".tag-dinnerto-go"]');
    var parentm = detagbtn.dataset.parentmenu;
    var parentel = document.querySelector(parentm);
    var allcats = parentel.querySelectorAll('.restMenus_cat');
    /* Remove active to all tag btns */
    thetagbtns.forEach(ebtn => { ebtn.classList.remove('active') });
    /* Remove active to all products */
    parentel.querySelectorAll('.restMenus_prod').forEach(prods => { prods.classList.remove('active'); });
    detagbtn.classList.add('active');
    parentel.classList.remove('all-visible');

    allcats.forEach(acs => {
        acs.classList.remove('active');
        console.log(acs);
    }); /* Remove active to all categories */
    parentel.querySelectorAll('.tag-dinnerto-go').forEach(dos => {
        dos.classList.add('active'); /* Add active to selected categories only */
        var activeproducts = dos.querySelectorAll('.prod-tag-dinnerto-go');
        if (activeproducts) { /* If we have tagged products */
            activeproducts.forEach(actProd => { actProd.classList.add('active'); });
        }
    });

    /* Set inicial scroll position */

    window.addEventListener("load", function () {
        var theYpos = document.querySelector('.restMenus__hero').clientHeight;
        this.setTimeout(() => {
            window.scrollTo(0, theYpos);
        }, 500);
    });
}

thetagbtns.forEach(tagbtn => {
    /* Function for each tag button */
    tagbtn.addEventListener('click', function (e) {
        e.preventDefault();
        thetagbtns.forEach(ebtn => { ebtn.classList.remove('active') });
        this.classList.add('active');
        var selector = this.dataset.timetag;
        var productsSelector = this.dataset.prodtag;
        var parentm = this.dataset.parentmenu;
        var parentel = document.querySelector(parentm); /* Parent element to choose elements in current menu only */
        var allcats = parentel.querySelectorAll('.restMenus_cat'); /* All categories in current menu */
        allcats.forEach(acs => { acs.classList.remove('active'); }); /* Remove active to all categories */
        /* Show disclimer on Lunch tag */
        if (selector == '.tag-lunch') {
            document.querySelector('.restMenus_tag-disclaimer').style.display = 'block';
        } else {
            document.querySelector('.restMenus_tag-disclaimer').style.display = 'none';
        }
        /* Remove active to all products */
        parentel.querySelectorAll('.restMenus_prod').forEach(prods => { prods.classList.remove('active'); })
        if (selector) {
            parentel.classList.remove('all-visible');
            allcats.forEach(acs => { acs.classList.remove('active'); }); /* Remove active to all categories */
            parentel.querySelectorAll(selector).forEach(dos => {
                dos.classList.add('active'); /* Add active to selected categories only */
                var activeproducts = dos.querySelectorAll(productsSelector);
                if (activeproducts) { /* If we have tagged products */
                    activeproducts.forEach(actProd => { actProd.classList.add('active'); });
                }
            });
        } else {
            parentel.classList.add('all-visible');
            allcats.forEach(acs => { acs.classList.add('active'); });
        }
        /* document.querySelectorAll('.restMenus_cat'). */
    })
});

// Functionality to deploy terms and conditions in specials quad
const specialsTermsButton = document.querySelector('#terms_btn');

if(specialsTermsButton) {
    specialsTermsButton.addEventListener('click', function(e) {
        e.preventDefault();
        const specialsTermsText = document.querySelector('.specialsTerms');
        specialsTermsText.classList.toggle('active');
    })
} 

